// Browser breakpoints
export const BREAKPOINT_XL = 1200
export const BREAKPOINT_L = 1025
export const BREAKPOINT_M = 768
export const BREAKPOINT_S = 576
